'use client';

import { useCallback } from 'react';

import useLocale from '@shaojiang/hooks/useLocale';
import { defaultLocale } from '@shaojiang/i18n/config';
import type { Locale } from '@shaojiang/types/i18n';

export const isExternalHref = (href: string) => /^(https?:|mailto:|tel:)/.test(href);

/**
 * Prefixes internal links with the current locale (English stays unprefixed); external links,
 * files and in-page anchors pass through unchanged.
 */
export default function useLocalizedHref() {
  const { locale: current } = useLocale();

  return useCallback(
    (href: string, locale?: Locale | '') => {
      const target = locale ?? current;
      if (isExternalHref(href) || href.startsWith('#') || /\.\w+$/.test(href)) return href;
      return target && target !== defaultLocale ? `/${target}${href === '/' ? '' : href}` : href;
    },
    [current],
  );
}
